import { useQuery } from '@tanstack/react-query';
import { fetchExamsByCategory } from '../services/examCategoryService';

export function useExamsByCategory(categoryId, options = {}) {
  return useQuery({
    queryKey: ['examsByCategory', Number(categoryId) || null, options?.isHome ? 1 : 0],
    queryFn: async () => {
      const { payload } = await fetchExamsByCategory({
        category_id: categoryId,
        is_home: options?.isHome ? 1 : 0,
      });

      return {
        examsList: Array.isArray(payload?.exams_list) ? payload.exams_list : [],
        categoryImage: payload?.category_image || '',
        categoryName: payload?.category_name || '',
      };
    },
    enabled: Boolean(categoryId),
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: (previousData) =>
      previousData ?? {
        examsList: [],
        categoryImage: '',
        categoryName: '',
      },
  });
}
